// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__dGyWY","error":"styles_error__1nGHZ"};